module.exports = __webpack_public_path__ + "img/SC3-About_you.dfb6af79.png";